import { render, staticRenderFns } from "./LogoutPage.vue?vue&type=template&id=6b3ca7cd&scoped=true&"
import script from "./LogoutPage.vue?vue&type=script&lang=js&"
export * from "./LogoutPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b3ca7cd",
  null
  
)

export default component.exports